import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
import { Plan } from "@modules/plan/Plan/Plan";
import { useMemo, useEffect, useState, useRef, FunctionComponent } from "react";
import { useLocation, matchPath, PathMatch } from "react-router";
import { Place } from "@modules/place/Place";
import { Tour } from "@modules/tour/Tour";
import { Goal } from "@modules/goal/Goal";
import { FeedPost } from "@modules/feedPost/FeedPost";
import { Event } from "@modules/event/Event";

import "./MobileScreenRouter.css";

const mobileScreenRoutes = [
  {
    path: "/places/:idOrSlug",
    component: Place,
  },
  {
    path: "/tours/:idOrSlug",
    component: Tour,
  },
  {
    path: "/events/:idOrSlug",
    component: Event,
  },
  {
    path: "/goals/:idOrSlug",
    component: Goal,
  },
  {
    path: "/challenges/:idOrSlug",
    component: Tour,
  },
  {
    path: "/feed_posts/:idOrSlug",
    component: FeedPost,
  },
  {
    path: "/plan",
    component: Plan,
  },
];

const MobileScreenRouter = () => {
  const { isMobile } = useWindowSize();

  if (!isMobile) {
    return null;
  }

  return <MobileScreenRouterInner />;
};

const MobileScreenRouterInner = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [animating, setAnimating] = useState(false);
  const location = useLocation();
  const lastMatch = useRef<
    | {
        match: PathMatch<string> | null;
        path: string;
        component: FunctionComponent;
      }
    | undefined
    | null
  >(null);

  const match = useMemo(() => {
    const matchNext = mobileScreenRoutes
      .map((route) => ({
        ...route,
        match: matchPath({ path: route.path, end: true }, pathname),
      }))
      .find((r) => r.match);

    const searchParams = new URLSearchParams(location.search);
    const planView = searchParams.get("planView");

    // TODO: probably need to centralize some of this logic as other screens like bottom sheet
    // entity list also need to work in concert with similar parallel logic, but hiding/showing
    // other pieces.
    if (
      matchNext?.path === "/plan" &&
      (planView === "navigate" || planView === "map")
    ) {
      return null;
    }

    if (location.search.includes("view=map")) {
      return null;
    }

    return matchNext;
  }, [pathname, location.search]);
  lastMatch.current = match ?? lastMatch.current;

  useEffect(() => {
    if (match) {
      setShow(true);
      setAnimating(true);
    } else if (show) {
      setAnimating(false);
      const timer = setTimeout(() => setShow(false), 350);
      return () => clearTimeout(timer);
    }
  }, [match, show]);

  const Component = lastMatch.current?.component;
  const params = lastMatch.current?.match?.params ?? {};

  return (
    <div
      className={`mobile-screen-router-container ${
        match && animating
          ? "mobile-screen-router-slide-in"
          : "mobile-screen-router-slide-out"
      }`}>
      {Component ? <Component {...params} /> : null}
    </div>
  );
};

export { MobileScreenRouter };
